import { LoginUserRole } from "../../services/data-list/get-login-user-role-list/GetLoginUserRoleListResponse";
import { Role } from "../../services/project/get-project/GetProjectResponse";

export type ProjectPlanPageState = {
  result: Result;
  infoBar: InfoBar;
  loginUserRoleList: LoginUserRole[];
  authorized: boolean;
};

export type Result = {
  projectInformation: ProjectInformation;
  ifReqSTmpUpdLastDTime?: string;
  ifReqSTmpUpdPath?: string;
  tstUseTypeCd?: string;
  tstUseTypeName?: string;
  componentRequirementList?: ComponentRequirementList[];
  costEstimation: CostEstimation;
  componentProjectList: ComponentProjectList[];
  stakeholderList: StakeholderList[];
  planStatus?: Status;
  executionStatus?: Status;
  invalidRoleList?: Role[];
  pjtLnchTypeCd: string;
  pjtLnchTypeName: string;
  updateDateTime: string;
  mmTxt: string;
  mmTxtUpdateDateTime: string;
};

export type ProjectInformation = {
  pjtName?: string;
  pjtDesc?: string;
  pjtStartPlnDate?: string;
  pjtEndPlnDate?: string;
  chnTypeGrpTypeCdList?: string[];
  chnTypeGrpTypeName?: string;
  trnsMsnTypeCd?: string;
  trnsMsnTypeName?: string;
  reqEstmtAnsDueDate?: string;
};

export type CostEstimation = {
  pjtBdgtAcqstnReqTypeCd?: string;
  pjtBdgtAcqstnReqTypeName?: string;
  statsOfAgreementOnBudgetaryTypeCd?: string;
  statsOfAgreementOnBudgetaryTypeName?: string;
};

export type ComponentRequirementList = {
  cpntReqId: string;
  dipByRgn: string;
  cpntId: string;
  cpntReqDesc: string;
};

export type ComponentProjectList = {
  pjtId: string;
  pjtName: string;
  pjtSts: string;
  pjtStsDsplyName: string;
};

export type StakeholderList = {
  stkhldrId: string;
  primFlg: string;
  roleCd: string;
  roleName: string;
  teamCd: string;
  userId: string;
  emplyNum: string;
  userName: string;
  mlAdrs: string;
  stkhldrNote?: string;
};

type Status = {
  tcktId: string;
  stsId: string;
  availebleNxtStsIds: string[];
  availableEvntGrps: string[];
};

export type InfoBar = {
  isShow: boolean;
  message: string;
  ready: string;
};

export type CrtPjtTcktReq = {
  confirmMessage: string;
  changedMassage: string;
};

export type UpdStsReq = {
  tcktId?: string;
  dialogType: string;
  confirmMessage: string;
  ok: {
    evntGrpTypeCd: string;
    preProcessParams?: Object;
    postProcessParams?: Object;
    changedMassage: string;
  };
  ng?: {
    evntGrpTypeCd: string;
    preProcessParams?: Object;
    postProcessParams?: Object;
    changedMassage: string;
  };
};

export type PageNewState =
  | ProjectPlanPageState
  | ((prevState: ProjectPlanPageState) => ProjectPlanPageState);
